import { useContext } from 'react';
import { ValidationContext, ValidationContextProps } from 'src/providers/ValidationContextProvider';

export function useValidationContext(): ValidationContextProps {
  return useContext(ValidationContext);
}

/**
 *
 * @remarks Removed previous implementation that derived isPdfOnly from validations.
 * Now returns true unconditionally to align with updated requirements of supporting only PDF uploads.
 */
export function useIsPdfOnly(): boolean {
  return true;
}
